module.exports = __webpack_public_path__ + "img/mainPicture.90f94f56.png";